import { useParams } from 'react-router';

import { List } from 'components/List';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = ['NPI', 'Organization Name'];
const columnWidths = [undefined, 400];

export const SupplierLocationsTab = () => {
    const { npi } = useParams();

    const otherSuppliers = useGet(`/reference/suppliers/`);

    return (
        <List
            pageTitle="Supplier Locations"
            columnNames={columns}
            columnWidths={columnWidths}
            isLoading={!otherSuppliers}
            listData={otherSuppliers
                ?.filter((s) => s.parent_supplier_npi === npi)
                .map((s) => [s.supplier_npi, s.organization_name])}
            createPath={`/supplier/${npi}/child/${CREATE_ROUTE}`}
            editPath={`/supplier/${npi}/child`}
            createButtonLabel="Add Supplier Location"
        />
    );
};
